module.exports = __webpack_public_path__ + "img/about-quotation.b67a726c.svg";